export function shouldPrefillCustomer(params: {
    hasPrefilled: boolean
    prefillCustomerId: string | null
    editingDraftId: string | null
    isLoadingCustomers: boolean
}): boolean {
    if (params.hasPrefilled) return false
    if (!params.prefillCustomerId) return false
    if (params.editingDraftId) return false

    return !params.isLoadingCustomers
}
